module.exports = __webpack_public_path__ + "img/myhy@2x.71e7ca6c.png";